export const validateField = (field, value, form = {}) => {
  switch (field) {
    case "email":
      if (!value) return "Email is required";
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value) ? "" : "Invalid email format";

    case "phone":
      if (!value) return "Phone number is required";
      return value.length < 8 ? "Phone number is too short" : "";

	    case "password": {
	      const pwd = value || "";
	      if (!pwd) return "Password is required";

	      // mêmes règles que le signup patient
	      const hasMinLength = pwd.length >= 8;
	      const hasUppercase = /[A-Z]/.test(pwd);
	      const hasLowercase = /[a-z]/.test(pwd);
	      const hasNumber = /[0-9]/.test(pwd);
	      const hasSpecial = /[@$!%*?&]/.test(pwd);

	      if (!(
	        hasMinLength &&
	        hasUppercase &&
	        hasLowercase &&
	        hasNumber &&
	        hasSpecial
	      )) {
	        // Message global, le détail est affiché via la checklist visuelle
	        return "Password does not meet all requirements";
	      }

	      // Si confirmPassword a déjà une valeur, vérifier la cohérence
	      if (form.confirmPassword && form.confirmPassword !== pwd) {
	        return "Password does not match confirm password";
	      }
	      return "";
	    }

    case "confirmPassword":
      if (!value) return "Please confirm your password";
      if (value !== (form.password || "")) return "Passwords do not match";
      return "";

    case "code":
      if (!value) return "Code is required";
      return /^[0-9]+$/.test(value) ? "" : "Code must be numeric";

    case "experience":
      if (!value) return "Experience number is required";
      return "";

    default:
      return "";
  }
};
